import React from "react";

import {
	RegistrationFormState
} from "./models";

import {
	Backdrop,
	Box,
	Button,
	CircularProgress,
	Grid,
	Link,
	Typography
} from "@mui/material";

import "./style.scss";

import {
	t,
	Trans
} from "@lingui/macro";

import {
	ZPlayFormField,
	ZPlayCheckbox
} from "commons/fields";

import * as Yup from "yup";
import { UseFormReturn } from "react-hook-form";
import { withUseFormHook } from "@sinossi/mates-react-library";
import AuthenticationService from "services/authentication-service";
import { withSnackbar, WithSnackbarProps } from "notistack";
import { Redirect } from "react-router-dom";
import { RegisterUserRequest } from "models/request";

const RegistrationSchema = Yup.object().shape({
	name: Yup.string().required(t({
		id: "cf-cs-name-required-msg",
		message: "Il nome è obbligatoria"
	})),
	surname: Yup.string().required(t({
		id: "cf-cs-surname-required-msg",
		message: "Il cognome è obbligatoria"
	})),
	email: Yup.string().email(t({
		id: "cf-cs-email-valid-msg",
		message: "Inserire un indirizzo e-mail valido"
	})).required(t({
		id: "cf-cs-email-required-msg",
		message: "L'indirizzo e-mail è obbligatorio"
	})),
	password: Yup.string().required(t({
		id: "cf-cs-password-required-msg",
		message: "La password è obbligatoria"
	})),
	repeatPassword: Yup.string().required(t({
		id: "cf-cs-repeat-password-required-msg",
		message: "È obbligatorio ripetere la password"
	})),
});

class RegistrationForm extends React.Component<UseFormReturn & WithSnackbarProps, RegistrationFormState>
{
	constructor(props: any) {

		super(props);

		this.state = {
			redirectToHome: false,
			loaded: false,
			isVerificationStep: false,
			insertedUsername: null
		};
	}

	componentDidMount() {
		this.setState(() => ({ loaded: true }));
	}

	submitRegistrationForm = (values: any) => {

		let registerUserRequest: RegisterUserRequest = {
			email: values.email,
			name: values.name,
			surname: values.surname,
			passwordConfirm: values.repeatPassword,
			password: values.password,
			tosConsent: values.tosConsent,
			newsletterConsent: values.newsletterConsent,
		};

		this.setState(() => ({ insertedUsername: values.email }));

		AuthenticationService.register(registerUserRequest, this.registrationCallback, this.registrationErrorCallback);
	};

	private registrationCallback = (response: any) => {

		this.setState(() => ({ isVerificationStep: true }));

	};

	private registrationErrorCallback = (response: any) => {

		this.props.enqueueSnackbar(t({
			id: "rf-error-registration",
			message: "Si è verificato un errore con la registrazione"
		}), {
			variant: "error",
		});

	};

	submitVerificationForm = (values: any) => {

		let verificationRequest = {
			username: this.state.insertedUsername,
			verificationCode: values.code
		};

		this.setState(() => ({ insertedUsername: values.email }));

		AuthenticationService.confirm(verificationRequest, this.confirmCallback, this.confirmErrorCallback);
	};

	private confirmCallback = () => {
		this.setState(() => ({ redirectToHome: true }));
	};

	private confirmErrorCallback = (response: any) => {

		this.props.enqueueSnackbar(t({
			id: "rf-error-confirm",
			message: "Si è verificato un errore con la verifica"
		}), {
			variant: "error",
		});

	};

	render() {
		return (<>
			{this.state.redirectToHome && <Redirect to={"/login?redirectReason=successful_reg"} />}
			<Box className={"registration-form-container"}>
				{!this.state.isVerificationStep &&
					<form onSubmit={this.props.handleSubmit(this.submitRegistrationForm)}>
						<Grid container rowSpacing={0.5} columnSpacing={1}>
							<Grid item xs={12}>
								<Typography variant="h1" component="div" color={"white"} gutterBottom
									sx={{
										textTransform: "uppercase",
										fontWeight: "bold"
									}}>
									<Trans id={"rf-register-title"}>
										Registrati
									</Trans>
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<ZPlayFormField
									label={t({
										id: "rf-name",
										message: "Nome"
									})}
									name="name"
									control={this.props.control}
									formState={this.props.formState}
									trigger={this.props.trigger}
								/>
							</Grid>
							<Grid item xs={6}>
								<ZPlayFormField
									label={t({
										id: "rf-surname",
										message: "Cognome"
									})}
									name="surname"
									control={this.props.control}
									formState={this.props.formState}
									trigger={this.props.trigger}
								/>
							</Grid>
							<Grid item xs={12}>
								<ZPlayFormField
									label={t({
										id: "rf-email",
										message: "Email"
									})}
									name="email"
									control={this.props.control}
									formState={this.props.formState}
									trigger={this.props.trigger}
								/>
							</Grid>
							<Grid item xs={12}>
								<ZPlayFormField
									label={t({
										id: "rf-password",
										message: "Password"
									})}
									name="password"
									type="password"
									control={this.props.control}
									formState={this.props.formState}
									trigger={this.props.trigger}
								/>
							</Grid>
							<Grid item xs={12}>
								<ZPlayFormField
									label={t({
										id: "rf-repeat-password",
										message: "Ripeti password"
									})}
									name="repeatPassword"
									type="password"
									control={this.props.control}
									formState={this.props.formState}
									trigger={this.props.trigger}
								/>
							</Grid>
							<Grid item xs={12}>
								<ZPlayCheckbox
									name="tosConsent"
									label={t({
										id: "rf-tos-consent",
										message: "Accetto i termini e le condizioni",
									})}
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}
								/>
							</Grid>
							<Grid item xs={12}>
								<ZPlayCheckbox
									name="newsletterConsent"
									label={t({
										id: "rf-newsletter-consent",
										message: "Desidero ricevere offerte speciali ed essere informato su promozioni e novità",
									})}
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}
								/>
							</Grid>
							<Grid item xs={12}>
								<Button variant="contained"
									color={"secondary"}
									size={"large"}
									fullWidth
									disabled={this.props.formState.isSubmitting}
									type="submit"
									sx={{
										mt: "60px",
										textTransform: "none",
									}}>
									<Trans id={"rf-register-button"}>Registrati</Trans>
								</Button>
							</Grid>
							<Grid item xs={12}>
								<br />
								<Typography variant="body2" component="div" color={"white"} gutterBottom
									sx={{
										textAlign: "center"
									}}>
									<Trans id={"rf-register-text"}>Possiedi già un account?</Trans>
									<br />
									<Link className={"registration-link"}
										href="/login"
										variant="body2"
										color="secondary"><Trans id={"rf-access-link"}>Accedi</Trans></Link>
								</Typography>
							</Grid>
						</Grid>
					</form>}
				{(this.state.loaded && this.state.isVerificationStep) &&
					<form onSubmit={this.props.handleSubmit(this.submitVerificationForm)}>
						<Grid container rowSpacing={0.5} columnSpacing={1}>
							<Grid item xs={12}>
								<Typography variant="h1" component="div" color={"white"} gutterBottom
									sx={{
										textTransform: "uppercase",
										fontWeight: "bold"
									}}>
									<Trans id={"rf-confirm-title"}>
										Conferma E-Mail
									</Trans>
								</Typography>
							</Grid>
							<Grid item xs={12}>
								<Typography variant="body1" component="div" color={"white"} gutterBottom
									sx={{
										textTransform: "uppercase",
										fontWeight: "bold"
									}}>
									<Trans id={"rf-confirm-text"}>
										Gentile utente, ti è stata inviata una E-Mail contentente un codice di conferma
										all'indirizzo precedentemente indicato. Qualora non avessi ricevuto nulla,
										controlla
										nella cartella "Spam". Se non dovessi ricevere alcun messaggio entro i 15
										minuti,
										contatta la nostra assistenza.
									</Trans>
								</Typography>
							</Grid>
							<Grid item xs={12}>
								<ZPlayFormField
									label={t({
										id: "rf-confirmation-code",
										message: "Codice di verifica"
									})}
									name="code"
									control={this.props.control}
									formState={this.props.formState}
									trigger={this.props.trigger}
								/>
							</Grid>
							<Grid item xs={12}>
								<Button variant="contained"
									color={"secondary"}
									size={"large"}
									fullWidth
									disabled={this.props.formState.isSubmitting}
									type="submit"
									sx={{
										mt: "60px",
										textTransform: "none",
									}}>
									<Trans id={"rf-confirm-button"}>Conferma</Trans>
								</Button>
							</Grid>
						</Grid>
					</form>}
			</Box>
			<Backdrop
				sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={!this.state.loaded}
			>
				<CircularProgress color="inherit" size="7rem" />
			</Backdrop>
		</>);
	}
}

const componentWithForm = withUseFormHook<{}>(RegistrationForm, RegistrationSchema, {});

export default withSnackbar(componentWithForm);